import { console } from 'react-redux-app/lib/modules/core/utils';
import { handleOnEnterException } from 'react-redux-app/lib/modules/routing/utils';

import { INTERNAL_ERROR_URI } from 'react-redux-app/lib/modules/routing/constants';
import { maybeHandleCriticalError } from 'react-redux-app/lib/modules/api/utils';

import { actionLoadSiteGoogleAnalyticsRequest } from '../../actions/loadSiteGoogleAnalytics';
import { getLoadSiteGoogleAnalyticsError } from '../../selectors/errors';


export default ({ getState, dispatch }) => (
  function loadSiteGoogleAnalyticsHandler(nextState, successCallback, errorCallback) {
    dispatch(
      actionLoadSiteGoogleAnalyticsRequest()
    ).then(
      () => {
        if (handleOnEnterException(getState(), errorCallback, INTERNAL_ERROR_URI)) {
          return;
        }

        const error = getLoadSiteGoogleAnalyticsError(getState());
        if (
          error
          && maybeHandleCriticalError(nextState.location, error.globalErrors, errorCallback)
        ) {
          return;
        }

        successCallback();
      }
    ).catch(error => {
      console.consoleError('loadSiteGoogleAnalyticsHandler failed', error);
      errorCallback(INTERNAL_ERROR_URI);
    });
  }
);
